// extracted by mini-css-extract-plugin
module.exports = {"container":"newBusinessInsightsMenu_container___ixPu","insightsList":"newBusinessInsightsMenu_insightsList__1-dfJ","active":"newBusinessInsightsMenu_active__2Xy0K"};